import { isMobileOnly } from 'react-device-detect';

export const getDeviceViewPort = () => {
  let width = Math.min(window.outerWidth, document.documentElement.clientWidth);
  let height = Math.min(window.outerHeight, document.documentElement.clientHeight);
  width = width || document.documentElement.clientWidth;
  height = height || document.documentElement.clientHeight;
  const ratio = height / width;
  if (!isMobileOnly && !checkDevToolsOpen()) {
    width = Math.min(window.innerWidth, document.documentElement.clientWidth);
    height = width * ratio;
  }

  return { width, height };
};

const checkDevToolsOpen = () => {
  const threshold = 120; // Minimum width/height of DevTools
  return window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold;
};
